// extracted by mini-css-extract-plugin
module.exports = {"top":"DQ","bottom":"EQ","new":"FQ","styleRoom":"GQ","isTrusted":"HQ","productLink":"IQ","details":"JQ","mainText":"KQ","subText":"LQ","colorName":"MQ","storeWrapper":"NQ"};